import React, { useEffect, useState } from "react";
import { useLocation, Link } from "react-router-dom";
import { useCountryStore } from "../../store/countryStore.js";
import { useMoneyPageStore } from "../../store/moneyPageStore.js";
import { Input, Select, message } from "antd";
import CloudEditor from "../../components/editor/editor-cdn";
import { maritalStatus, residencyStatus } from "../../utils/arrayitems";

import Loader from "../../components/loader/loader";
import { PrimaryButton, VioletButtonLarge } from "../../components/button";

const { TextArea } = Input;

const MoneyPageDetails = () => {
  const location = useLocation();
  const {
    moneyPage,
    isMoneypageLoading,
    getMoneyPage,
    updateMoneyPage,
    getMoneyPages,
  } = useMoneyPageStore();
  const { countries, states, getStates } = useCountryStore();

  const id = location?.pathname?.split("/")[2];

  const [otherSearchArray, setOtherSearchArray] = useState([]);
  const [state, setState] = useState({
    id: "",
    metaDescription: "",
    metaKeyword: "",
    otherSearchKeyword: "",
    pageHeader: "",
    pageParagraph: "",
    pageTitle: "",
    pageUrl: "",
    relatedSearch: "",
    searchingParams: {
      country: "",
      stateProvince: "",
      city: "",
      gender: "",
      maritalStatus: "",
      residencyStatus: "",
    },
    status: "",
  });

  useEffect(() => {
    fetchMoneyPage();
  }, []);

  useEffect(() => {
    setState({
      metaDescription: moneyPage?.metaDescription,
      metaKeyword: moneyPage?.metaKeyword,
      otherSearchKeyword: moneyPage?.otherSearchKeyword,
      pageHeader: moneyPage?.pageHeader,
      pageParagraph: moneyPage?.pageParagraph,
      pageTitle: moneyPage?.pageTitle,
      pageUrl: moneyPage?.pageUrl,
      relatedSearch: moneyPage?.relatedSearch,
      searchingParams: {
        country: moneyPage?.searchingParams?.country,
        stateProvince: moneyPage?.searchingParams?.stateProvince,
        city: moneyPage?.searchingParams?.city,
        gender: moneyPage?.searchingParams?.gender,
        maritalStatus: moneyPage?.searchingParams?.maritalStatus,
        residencyStatus: moneyPage?.searchingParams?.residencyStatus,
      },
      status: moneyPage?.status,
    });
  }, [moneyPage]);

  useEffect(() => {
    const payload = { country: [state?.searchingParams?.country] };
    getStates(payload);
  }, [state?.searchingParams?.country]);

  useEffect(() => {
    const otherSearchParams = parseOtherSearchKeyword();
    setOtherSearchArray(otherSearchParams);
  }, [state?.otherSearchKeyword]);

  const fetchMoneyPage = async () => {
    getMoneyPage({ id });
  };

  const handleSubmit = () => {
    if (!state?.status) {
      message.error("Status is required");
      return;
    }

    const isSearchingParamsEmpty = Object.values(state.searchingParams).every(
      (value) => !value
    );

    if (
      state?.status !== "draft" &&
      (!state?.pageUrl ||
        !state?.pageHeader ||
        !state?.pageTitle ||
        !state?.pageParagraph ||
        !state?.status ||
        isSearchingParamsEmpty)
    ) {
      message.error("Please fill all the required fields");
      return;
    }

    const removeEmptyFields = (obj) => {
      return Object.entries(obj)
        .filter(
          ([_, value]) => value !== "" && value !== null && value !== undefined
        )
        .reduce(
          (acc, [key, value]) => ({
            ...acc,
            [key]:
              typeof value === "object" && !Array.isArray(value)
                ? removeEmptyFields(value)
                : value,
          }),
          {}
        );
    };

    const cleanedState = removeEmptyFields(state);

    const formattedOtherSearchKeyword = otherSearchArray.reduce(
      (acc, item, index) => {
        acc[index + 1] = item;
        return acc;
      },
      {}
    );

    const payload = {
      id: id,
      data: {
        ...cleanedState,
        otherSearchKeyword: JSON.stringify(formattedOtherSearchKeyword),
      },
    };

    updateMoneyPage(payload, (res) => {
      if (res.status === 200) {
        getMoneyPages({});
      }
    });
  };

  const handleEditorChange = (content) => {
    setState((prev) => ({
      ...prev,
      pageParagraph: content,
    }));
  };

  const parseOtherSearchKeyword = () => {
    try {
      const parsedKeywords = JSON.parse(state.otherSearchKeyword);
      return Object.values(parsedKeywords);
    } catch (error) {
      console.error("Error parsing otherSearchKeyword:", error);
      return [];
    }
  };

  const handleAddOtherSearch = () => {
    setOtherSearchArray((prev) => [...prev, { text: "", url: "" }]);
  };

  const handleRemoveOtherSearch = (index) => {
    setOtherSearchArray((prev) => prev.filter((_, idx) => idx !== index));
  };

  const handleOtherSearchChange = (index, key, value) => {
    setOtherSearchArray((prev) =>
      prev.map((item, idx) =>
        idx === index ? { ...item, [key]: value } : item
      )
    );
  };

  return isMoneypageLoading ? (
    <Loader />
  ) : (
    <div className="px-3 py-4 flex flex-col gap-5">
      <div className="flex flex-col gap-3">
        <div className="flex flex-col gap-2">
          <div>
            Page Url *{" "}
            <span className="text-blue-500 underline">
              <Link
                to={`https://noblemarriage.com/${state?.pageUrl}`}
                target="_blank"
              >
                Visit
              </Link>
            </span>
          </div>
          <div className="flex gap-1 items-center">
            <span className="text-[14px] text-gray-500">
              noblemarriage.com/
            </span>
            <Input
              style={{ height: 48 }}
              className="moneyPage"
              placeholder="Page URL"
              onChange={(e) => setState({ ...state, pageUrl: e.target.value })}
              value={state.pageUrl}
            />
          </div>
        </div>
        <div className="flex flex-col gap-2">
          <div>Page Title *</div>
          <Input
            style={{ height: 48 }}
            className="moneyPage"
            placeholder="Page Title"
            onChange={(e) => setState({ ...state, pageHeader: e.target.value })}
            value={state.pageHeader}
          />
        </div>
        <div className="flex flex-col gap-2">
          <div>Meta Title *</div>
          <Input
            style={{ height: 48 }}
            className="moneyPage"
            placeholder="Meta Title"
            onChange={(e) => setState({ ...state, pageTitle: e.target.value })}
            value={state.pageTitle}
          />
        </div>
        <div className="flex flex-col gap-2">
          <div>Short Description *</div>
          <div className="bg-white border border-gray-300 rounded-lg p-2">
            <CloudEditor
              data={state?.pageParagraph}
              onChange={handleEditorChange}
            />
          </div>
        </div>
      </div>
      <div className="text-[20px] pb-4 border-b border-b-gray-400">
        SEO Section
      </div>
      <div className="flex flex-col gap-3">
        <div className="flex flex-col gap-2">
          <div>SEO Keywords</div>

          <Input
            style={{ height: 48 }}
            className="moneyPage"
            placeholder="Page URL"
            onChange={(e) =>
              setState({ ...state, metaKeyword: e.target.value })
            }
            value={state.metaKeyword}
          />
        </div>
        <div className="flex flex-col gap-2">
          <div>SEO Description</div>

          <TextArea
            rows={4}
            className="moneyPage"
            placeholder="Page URL"
            onChange={(e) =>
              setState({ ...state, metaDescription: e.target.value })
            }
            value={state.metaDescription}
          />
        </div>
      </div>
      <div className="text-[20px] pb-4 border-b border-b-gray-400">
        Filter Fields *
      </div>
      <div className="grid grid-cols-3 gap-10">
        <div className="flex flex-col gap-2">
          <div>Select Country</div>

          <Select
            style={{ height: 48 }}
            className="moneyPage"
            showSearch
            placeholder="Select a country"
            filterOption={(input, option) =>
              (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
            }
            options={countries?.map((item) => ({
              label: item?.name,
              value: item?.name,
            }))}
            allowClear
            value={state?.searchingParams?.country}
            onChange={(e) =>
              setState({
                ...state,
                searchingParams: { ...state?.searchingParams, country: e },
              })
            }
          />
        </div>
        <div className="flex flex-col gap-2">
          <div>Select State</div>

          <Select
            style={{ height: 48 }}
            className="moneyPage"
            showSearch
            placeholder="Select a state"
            filterOption={(input, option) =>
              (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
            }
            allowClear
            options={states?.map((item) => ({
              label: item?.name,
              value: item?.name,
            }))}
            value={state?.searchingParams?.stateProvince}
            onChange={(e) =>
              setState({
                ...state,
                searchingParams: {
                  ...state?.searchingParams,
                  stateProvince: e,
                },
              })
            }
          />
        </div>
        <div className="flex flex-col gap-2">
          <div>Select City</div>

          <Select
            disabled
            style={{ height: 48 }}
            className="moneyPage"
            showSearch
            allowClear
            placeholder="Select a city"
            filterOption={(input, option) =>
              (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
            }
            options={states?.map((item) => ({
              label: item?.name,
              value: item?.name,
            }))}
            value={state?.searchingParams?.city}
            onChange={(e) =>
              setState({
                ...state,
                searchingParams: {
                  ...state?.searchingParams,
                  city: e,
                },
              })
            }
          />
        </div>
        <div className="flex flex-col gap-2">
          <div>Marital Status</div>

          <Select
            style={{ height: 48 }}
            className="moneyPage"
            showSearch
            placeholder="Select martial status"
            filterOption={(input, option) =>
              (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
            }
            allowClear
            options={maritalStatus}
            value={state?.searchingParams?.maritalStatus}
            onChange={(e) =>
              setState({
                ...state,
                searchingParams: {
                  ...state?.searchingParams,
                  maritalStatus: e,
                },
              })
            }
          />
        </div>
        <div className="flex flex-col gap-2">
          <div>Residency Status</div>

          <Select
            style={{ height: 48 }}
            className="moneyPage"
            showSearch
            placeholder="Select residency status"
            filterOption={(input, option) =>
              (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
            }
            allowClear
            options={residencyStatus}
            value={state?.searchingParams?.residencyStatus}
            onChange={(e) =>
              setState({
                ...state,
                searchingParams: {
                  ...state?.searchingParams,
                  residencyStatus: e,
                },
              })
            }
          />
        </div>
        <div className="flex flex-col gap-2">
          <div>Gender</div>

          <Select
            style={{ height: 48 }}
            className="moneyPage"
            showSearch
            placeholder="Select gender"
            filterOption={(input, option) =>
              (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
            }
            allowClear
            options={[
              {
                value: "male",
                label: "Male",
              },
              {
                value: "female",
                label: "Female",
              },
            ]}
            value={state?.searchingParams?.gender}
            onChange={(e) =>
              setState({
                ...state,
                searchingParams: {
                  ...state?.searchingParams,
                  gender: e,
                },
              })
            }
          />
        </div>
      </div>
      <div className="text-[20px] pb-4 border-b border-b-gray-400">
        You Might Also be Interested In
      </div>
      <div className="flex flex-col gap-3">
        {otherSearchArray.map((item, index) => (
          <div key={index} className="flex gap-2 items-center">
            <Input
              style={{ height: 48 }}
              className="moneyPage"
              placeholder="Text"
              onChange={(e) =>
                handleOtherSearchChange(index, "text", e.target.value)
              }
              value={item.text}
            />
            <Input
              style={{ height: 48 }}
              className="moneyPage"
              placeholder="URL"
              onChange={(e) =>
                handleOtherSearchChange(index, "url", e.target.value)
              }
              value={item.url}
            />
            <PrimaryButton
              type="danger"
              onClick={() => handleRemoveOtherSearch(index)}
              text="Remove"
              style={{ width: "200px" }}
            />
          </div>
        ))}
        <VioletButtonLarge
          type="primary"
          onClick={handleAddOtherSearch}
          text="Add More"
        />
      </div>
      <div className="flex flex-col gap-2">
        <div>Related Search</div>

        <Input
          style={{ height: 48 }}
          className="moneyPage"
          placeholder="Page URL"
          onChange={(e) =>
            setState({ ...state, relatedSearch: e.target.value })
          }
          value={state.relatedSearch}
        />
      </div>
      <div className="flex flex-col gap-2">
        <div>Want to Publish? *</div>

        <Select
          style={{ height: 48, width: 200 }}
          className="moneyPage"
          showSearch
          placeholder="Select residency status"
          filterOption={(input, option) =>
            (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
          }
          options={[
            {
              value: "published",
              label: "Published",
            },
            {
              value: "draft",
              label: "Draft",
            },
          ]}
          value={state?.status}
          onChange={(e) =>
            setState({
              ...state,
              status: e,
            })
          }
        />
      </div>
      <div className="flex gap-3 items-center">
        <PrimaryButton
          text="Save"
          style={{ width: "200px" }}
          onClick={handleSubmit}
        />
        <VioletButtonLarge
          text="Cancel"
          style={{ width: "200px" }}
          onClick={() => window.history.back()}
        />
      </div>
    </div>
  );
};

export default MoneyPageDetails;








